<script lang="ts">
    import type {MessageContactRegistered} from "./Types";
</script>
<div class="alert alert-primary m-0">Контакт зареєстрований</div>
